import { ImageGrid } from './image-grid.component';

export * from './image-grid.component';
export default ImageGrid;

ImageGrid.define('der-ui-image-grid');

declare global {
    interface HTMLElementTagNameMap {
        'der-ui-image-grid': ImageGrid;
    }
}
